/*
  WellHome · fachada de vídeo.

  Hasta que alguien pulsa, en la página NO hay ningún iframe: solo la miniatura que
  sirve el CDN de Shopify. Este script inyecta el reproductor en el clic, y ese clic
  es el consentimiento: el aviso de cookies está a la vista justo debajo del botón.

  Se carga con `defer` desde la sección y solo en fichas que tengan vídeo externo.
*/
if (!customElements.get('wh-video-facade')) {
  customElements.define('wh-video-facade', class extends HTMLElement {
    connectedCallback() {
      // Un solo listener en el contenedor: el botón desaparece al reproducir, así que
      // engancharlo a él obligaría a limpiarlo después.
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.whvf-trigger')) return;
        this.play();
      });
    }

    play() {
      const src = this.dataset.embed;
      if (!src || this.dataset.playing === 'true') return;
      this.dataset.playing = 'true';

      const frame = document.createElement('iframe');
      frame.className = 'whvf-frame';
      frame.src = src;
      frame.title = this.dataset.title || '';
      frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      frame.setAttribute('allowfullscreen', '');
      // Google recibe el dominio, no la URL completa de la ficha.
      frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

      // Se vacía la fachada entera, aviso incluido: una vez aceptado y cargado, el
      // texto ya no informa de nada que no haya pasado.
      this.replaceChildren(frame);
    }
  });
}
